import { getLeFEOrigin } from '@utils/util';

export const LotteryRecordLeFE = () => (
    <iframe className="admin-iframe" title="中奖列表" src={`${getLeFEOrigin()}/#/app/admin/lottery_record`} />
);
